import axiosVApi from "../axiovishwam";

const systemCheck = async (request) => {
    try {
        request = request || {};
        const response = await axiosVApi.post(`SystemCheck/SystemCheck`, request);
        return response?.data;
    } catch (error) {
        console.log("Error systemCheck===>:", error);
    }
};

export const SystemCheckService = {
    systemCheck,
}